import { RelationModuleSpecialtiesStruct } from "../../structs/user/relation-module-specialties.struct";

export class ModuleServiceSpecialtiesRequest {
    public listRelationModuleSpecialtiesStruct: RelationModuleSpecialtiesStruct[] = [];
}